// extracted by mini-css-extract-plugin
export default {"root":"LastSaveDraft_root__Bqe8i","text":"LastSaveDraft_text__jhSQS","icon":"LastSaveDraft_icon__FYGiA"};